module.exports = __webpack_public_path__ + "img/time_line_circular_hexagon_order.7297df3b.svg";